import styled from 'styled-components';
import { Base, Theme } from 'styled';
import { Color } from 'styled/theme/colors';

type ChoiceContainerProps = {
  totalNumberOfChoices: number;
  choiceSelectHasConnectorOnRightSide: boolean;
};

type ConnectorProps = {
  color: Color;
};

export const Container = styled(Base)`
  display: flex;
  flex-direction: column;
`;

export const LabelContainer = styled(Base)`
  display: flex;
  justify-content: space-between;
`;

export const Label = styled.p`
  ${({ theme }) => theme.typography.variants.primary.xs};

  ${Theme.mediaQueries.md} {
    ${({ theme }) => theme.typography.variants.primary.sm};
  }
`;

export const ChoicesContainer = styled(Base)`
  display: flex;
  justify-content: space-between;
`;

export const ChoiceContainer = styled(Base)<ChoiceContainerProps>`
  position: relative;
  width: ${({ totalNumberOfChoices, choiceSelectHasConnectorOnRightSide }) =>
    choiceSelectHasConnectorOnRightSide
      ? `calc(${100 / totalNumberOfChoices}% + 3px)`
      : 'auto'};
`;

export const Button = styled(Base)``;

export const Connector = styled(Base)<ConnectorProps>`
  position: absolute;
  width: 100%;
  height: 3px;
  top: calc(50% - 3px);
  left: 20px;
  background-color: ${({ theme, color }) => theme.colors[color]};
`;
